var React = require('react');

function Megaphone (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M480 64L64 192v128l101.72 31.3a96 96 0 1 0 183.33 56.41L480 448zM256 432a48 48 0 0 1-44.27-66.54L303 393.55A48.07 48.07 0 0 1 256 432z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M560 32h-32a16 16 0 0 0-16 16v416a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM32 160a32 32 0 0 0-32 32v128a32 32 0 0 0 64 0V192a32 32 0 0 0-32-32z","className":"fa-primary","key":2})]);
}

Megaphone.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Megaphone;

Megaphone.default = Megaphone;
